import { call, put } from "redux-saga/effects";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getTotalRevenue(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_TOTAL_REVENUE, action.payload, true);
}

export function* getAvgSalesTicket(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_AVG_SALES_TICKET, action.payload, true);
}

export function* getExpenseTotal(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_EXPENSE_TOTAL, action.payload, true);
}

export function* getGrossMarginPercentage(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_GROSS_MARGIN_PERCENTAGE, action.payload, true);
}

export function* getOnlineVsOffline(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_ONLINE_VS_OFFLINE, action.payload, true);
}

export function* getRepeatCustomerPercentage(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_REPEAT_CUSTOMER_PERCENTAGE, action.payload, true);
}

export function* getGrossMarginChart(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_GROSS_MARGIN_CHART, action.payload, true);
}

export function* getRevenueExpenseChart(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_REVENUE_EXPENSE_CHART, action.payload, true);
}

export function* getPurchaseCostChart(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_PURCHASE_COST_CHART, action.payload, true);
}

export function* getSalesVolumeChart(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_SALES_VOLUME_CHART, action.payload, true);
}

export function* getTopProducts(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_TOP_PRODUCTS, action.payload, true);
}

export function* getTopPromotions(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_TOP_PROMOTIONS, action.payload, true);
}

export function* getTopCategories(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_TOP_CATEGORIES, action.payload, true);
}

export function* getTopSalesPerson(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_TOP_SALES_PERSON, action.payload, true);
}

export function* getEmployeeWorkTime(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_EMPLOYEE_WORK_TIME, action.payload, true);
}

export function* getCustomerComparison(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_CUSTOMER_COMPARISON, action.payload, true);
}

export function* getAvgSalesTicketComparison(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_AVG_SALES_TICKET_COMPARISON, action.payload, true);
}

export function* getRepeatCustomerComparison(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_REPEAT_CUSTOMER_COMPARISON, action.payload, true);
}

export function* getGrossSalesNetSalesChart(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_GROSS_SALES_NET_SALES_CHART, action.payload, true);
}

export function* getGrossCostLaborCostChart(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_GROSS_COST_LABOR_COST_CHART, action.payload, true);
}

export function* getReturnsRefundsTrend(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_RETURNS_REFUNDS_TREND, action.payload, true);
}

export function* getVoidsCancellations(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_VOIDS_CANCELLATIONS, action.payload, true);
}

export function* getTransactionVolume(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_TRANSACTION_VOLUME, action.payload, true);
}

export function* getSalesByPaymentMethod(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_SALES_BY_PAYMENT_METHOD, action.payload, true);
}

export function* getPointsIssuedByLoyaltyType(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_POINTS_ISSUED_BY_LOYALTY_TYPE, action.payload, true);
}

export function* getSalesTrendByHour(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_SALES_TREND_BY_HOUR, action.payload, true);
}

export function* getSalesBreakdown(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_SALES_BREAKDOWN, action.payload, true);
}

export function* getPointsRedeemedByLoyaltyType(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_POINTS_REDEEMED_BY_LOYALTY_TYPE, action.payload, true);
}

export function* getParticipationRateByLoyaltyType(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_PARTICIPATION_RATE_BY_LOYALTY_TYPE, action.payload, true);
}

export function* getGrossSales(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_GROSS_SALES, action.payload, true);
}

export function* getNetSales(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_NET_SALES, action.payload, true);
}

export function* getCostOfGoodsSold(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_COST_OF_GOODS_SOLD, action.payload, true);
}

export function* getGrossMargin(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_GROSS_MARGIN, action.payload, true);
}

export function* getLaborCost(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_LABOR_COST, action.payload, true);
}

export function* getNumOfTransactions(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_NUM_OF_TRANSACTIONS, action.payload, true);
}

export function* getLowPerformingProducts(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.DASHBOARD.GET_LOW_PERFORMING_PRODUCTS, action.payload, true);
}
